import type { IntlShape } from 'react-intl';

export const hasInvalidMapping = (
  errors: { invalidFieldMappingIds: string[] },
  fieldId: string,
) => errors.invalidFieldMappingIds.includes(fieldId);

export const getErrorMessage = (
  errors: { invalidFieldMappingIds: string[] },
  fieldId: string,
  fieldMapping: { [key: string]: number },
  intl: IntlShape,
) => {
  if (hasInvalidMapping(errors, fieldId)) {
    if (fieldMapping[fieldId] === 0) {
      return intl.formatMessage({
        id: 'FieldsUtils.fieldMappingNotFound',
        defaultMessage:
          'Field mapping not found. Assign it to an existing field in Settings.',
        description: 'Error message when field mapping is not found',
      });
    }
    return intl.formatMessage({
      id: 'FieldsUtils.dataMappingError',
      defaultMessage:
        'Data Fields Mapping Error. The field type is incompatible with the mapped data in Settings.',
      description:
        'Error message when field type is incompatible with mapped data',
    });
  }

  return undefined;
};
